import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

export const reviewFormSelector = (state) => state;

export const reviewSubmittingSelector = createSelector(
  reviewFormSelector,
  (state) => state.reviews.reviewSubmitting,
);

export const reviewSubmittingError = createSelector(
  reviewFormSelector,
  (state) => state.reviews.reviewSubmittingError,
);

const submitReviewFormSelector = formValueSelector('submitReviewForm');

export const reviewRatingSelector = (state) => submitReviewFormSelector(state, 'rating');

export const reviewSubmittedSelector = createSelector(
  reviewFormSelector,
  (state) => state.reviews.reviewSubmitted,
);
